class BlogCategorySearch extends HTMLElement{
  constructor(){
    super();
    this.input = this.querySelector("input")
    this.input.addEventListener("keyup", this.blogSearchInput.bind(this));
    this.categorySearch = this.closest('.blog-article_category-wrapper').querySelectorAll("li.blog__nav-item")
  }

  blogSearchInput(evt){
    evt.preventDefault()
    let keyWord = evt.currentTarget.value
    let rgx = new RegExp( "(?:^|\\s)" + keyWord.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), "i" );

    if (keyWord.length > 0) {
      Array.from(this.categorySearch).forEach(ele=>ele.classList.add("hidden"));
    }

    Array.from(Array.from(this.categorySearch).filter(category => rgx.test(category.dataset.value) &&  keyWord.length > 0)
    ).map(matchedValue => matchedValue.classList.remove("hidden"))

    if (keyWord.length == 0) {
      Array.from(this.categorySearch).forEach(ele=>ele.classList.remove("hidden"));
    }
  }
}

customElements.define('custom-search', BlogCategorySearch)